export class PaginatorFilter {
  pageSize: number = 10;
  currentPage: number = 0;
  count: number = 0;
  defaultPageSize?: number = 10;
  startDate?: Date = undefined;
  endDate?: Date = undefined;
  searchText: string = "";
  skip: number = 0;

  constructor(init?: Partial<PaginatorFilter>) {
    Object.assign(this, init);
  }

  clearDates() {
    this.startDate = undefined;
    this.endDate = undefined;
  }
}
